import { combineReducers } from "@reduxjs/toolkit";
import {
  checkUserReviewReducer,
  getAllReviewsInstructorReducer,
  getAllReviewsUserReducer,
  getCourseReviewsReducer,
  getCourseReviewSummaryReducer,
  getInstructorReviewSummaryReducer,
  getTotalReviewInstructorReducer,
  getTotalReviewUserReducer,
  submitReviewCourseReducer,
  updateReviewCourseReducer,
} from "./slices";

const reviewReducer = combineReducers({
  getCourseReviews: getCourseReviewsReducer,
  submitReviewCourse: submitReviewCourseReducer,
  getAllReviewsUser: getAllReviewsUserReducer,
  updateReviewCourse: updateReviewCourseReducer,
  checkUserReview: checkUserReviewReducer,
  getCourseReviewSummary: getCourseReviewSummaryReducer,
  getTotalReviewUser: getTotalReviewUserReducer,
  getAllReviewsInstructor: getAllReviewsInstructorReducer,
  getTotalReviewInstructor: getTotalReviewInstructorReducer,
  getInstructorReviewSummary: getInstructorReviewSummaryReducer,
});

export default reviewReducer;
